<template>
    <div class="d-flex w-100">
      <div v-if="!details" class="d-flex w-100">
        <div class="col-md-3">
          <filterMunutencao @search="search"></filterMunutencao>
        </div>
        <div class="col-md-9">
          <colapse ref="collap"></colapse>
        </div>
      </div>
    </div>
</template>

<script>
import occurrenceMaintenance from './occurrenceMaintenance'
export default occurrenceMaintenance

</script>

  <style scoped>
   .col-md-3{
    padding-right: 0;
    padding-left: 0;
   }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/occurrenceMaintenance/occurrenceMaintenance.vue